<div class="container" style="border:1px solid #bebaba">
  <div class="row text-center background-bottom">
    <div class="col-md-12 text-center img-fluid" style="margin-top:2%; margin-bottom:2%; padding-right:2%; padding-left:2%">
      <p class="text-center" style="font-size:1.0em; color:white">
        This official website is maintained by the Notice Administrator for <i>In re Generic Pharmaceuticals Antitrust Litigation</i>,
        No. 16-MD-2724 pending in the United States District Court for the Eastern District of Pennsylvania.
      </p>
    </div>
  </div>
  <div class="row background">
    <div class="col-md-12">
      <a [routerLink]="['/home']">
        <img src="../assets/Main with CTA button.png" class="img-fluid" />
      </a>
    </div>
  </div>
  <div class="row mt-4" style="margin-left:5%;margin-right:5%">
    <div class="col-md-12 text-center">
      <p style="font-size:1.1em">
        Details about each Settlement can be found here:<br /><br />
        <a class="btn btn-outline-primary" [routerLink]="['/sun-taro-classes-homepage']">Sun/Taro Settlement Class for CONSUMERS and Third-Party Payers</a><br /><br />
        <a class="btn btn-outline-primary" [routerLink]="['/apotex-heritage-classes-homepage']">Apotex and Heritage Settlement Classes for Third-Party Payers</a><br /><br />
        <a class="btn btn-outline-primary" [routerLink]="['/sandoz-classes-homepage']">Sandoz Settlement Class for CONSUMERS and Third-Party Payers</a><br /><br />
        <div style="text-align:left; font-size:1.5em">
          To participate in the settlements, you must submit a claim form online or by U.S. Mail so that it is submitted or postmarked by <b>November 9, 2026</b>.
          Click  <a [routerLink]="['/home']">HERE</a> for the claim form.
          <b>Settlement Class members need not sign up with a claims recovery firm or pay another firm in order to participate in the settlements</b>.<br /><br />

          In addition, the Court has certified two litigation classes for Third-Party Payers. Information regarding those litigation classes can be found here:<br /><br />


        </div>
        <a class="btn btn-outline-primary" [routerLink]="['/certified-litigation-classes-homepage']">Certified Litigation Classes for Clomipramine / Clobetasol Third-Party Payers</a><br /><br />

</div>
  </div>
</div>
